/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
const IMAGE_PLACEHOLDER = '<image>';
const MAX_LOOP_COUNT = 100;
const MAX_IMAGE_LENGTH = 5;
const IMAGE_FACTOR = 28;
const DEFAULT_FACTOR = 1000;
const MIN_PIXELS = 100 * IMAGE_FACTOR * IMAGE_FACTOR;
const MAX_PIXELS_V1_0 = 2700 * IMAGE_FACTOR * IMAGE_FACTOR;
const MAX_PIXELS_DOUBAO = 5120 * IMAGE_FACTOR * IMAGE_FACTOR;
const MAX_PIXELS_V1_5 = 16384 * IMAGE_FACTOR * IMAGE_FACTOR;
const MAX_RATIO = 200;
var vlm_VlmModeEnum = /*#__PURE__*/ function(VlmModeEnum) {
    VlmModeEnum["Chat"] = "chat";
    VlmModeEnum["Agent"] = "agent";
    return VlmModeEnum;
}({});
var vlm_UITarsModelVersion = /*#__PURE__*/ function(UITarsModelVersion) {
    UITarsModelVersion["V1_0"] = "1.0";
    UITarsModelVersion["V1_5"] = "1.5";
    UITarsModelVersion["DOUBAO_1_5_15B"] = "doubao-1.5-15B";
    UITarsModelVersion["DOUBAO_1_5_20B"] = "doubao-1.5-20B";
    return UITarsModelVersion;
}({});
const VlmModeEnumOptions = {
    ["agent"]: "Agent \u6A21\u5F0F",
    ["chat"]: "Chat \u6A21\u5F0F"
};
export { DEFAULT_FACTOR, IMAGE_FACTOR, IMAGE_PLACEHOLDER, MAX_IMAGE_LENGTH, MAX_LOOP_COUNT, MAX_PIXELS_DOUBAO, MAX_PIXELS_V1_0, MAX_PIXELS_V1_5, MAX_RATIO, MIN_PIXELS, vlm_UITarsModelVersion as UITarsModelVersion, vlm_VlmModeEnum as VlmModeEnum, VlmModeEnumOptions };

//# sourceMappingURL=vlm.mjs.map